import {
  AgentDelegationKind,
  AgentDelegationTarget,
  AgentDelegationTaskType,
} from '@this+that/models';

/** EXECUTE only ever applies to an AGENT_RUN target — delegationFromLedger.ts's whole
 *  ledger-backed BLOCKED/NEEDS_APPROVAL path is driven by the executor, which runs on an
 *  AGENT_RUN conversation; a LOCAL_MCP_CODING target keeps TECHNICAL_ANALYSIS/IMPLEMENT_AND_PR
 *  (resolveTaskTypeForRuntime, shared via buildDelegationInputVariables.ts). Gated on the runtime flag so the option
 *  (and its preselection) stays off until API-CODE.02/API-P3.01 are live for this delegator. */
export function canOfferExecuteTaskType(
  target: AgentDelegationTarget,
  executeDelegationFlag: boolean,
): boolean {
  return executeDelegationFlag && target.kind === AgentDelegationKind.AGENT_RUN;
}

/** The task type a delegate entry point starts with, shared by the Delegate menu and the
 *  composer's "To:" picker. A custom-agent target has no plan/implement choice to make: it runs
 *  its own job, so it gets EXECUTE when the viewer may use it and the read-only analysis
 *  otherwise. A local coding target keeps the user's Plan-first choice. */
export function resolveDefaultDelegationTaskType(
  target: AgentDelegationTarget,
  executeDelegationFlag: boolean,
  planFirst = true,
): AgentDelegationTaskType {
  if (canOfferExecuteTaskType(target, executeDelegationFlag)) {
    return AgentDelegationTaskType.EXECUTE;
  }
  if (target.kind === AgentDelegationKind.AGENT_RUN || planFirst) {
    return AgentDelegationTaskType.TECHNICAL_ANALYSIS;
  }
  return AgentDelegationTaskType.IMPLEMENT_AND_PR;
}
